export const pluralize = (count: number, noun: string, suffix = "s") => {
  if (noun === "is") return `${count !== 1 ? "are" : noun}`;
  return `${noun}${count !== 1 ? suffix : ""}`;
};
